import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogTemplateComponent } from '@optsolservices/ngx-confirm-dialog';
import { NotificationService } from '@optsolservices/ngx-notification';
import { BaseService } from 'src/app/core/services/base.service';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';
import { PrintTriggerDialogComponent } from 'src/app/shared/print-trigger-dialog/print-trigger-dialog.component';

@Component({
  selector: 'app-pos-tfg-account-pay-with-money-equipment',
  templateUrl: './pos-tfg-account-pay-with-money-equipment.component.html',
  styleUrls: ['./pos-tfg-account-pay-with-money-equipment.component.scss']
})
export class PosTfgAccountPayWithMoneyEquipmentComponent implements OnInit {
  tfgAccountDetails: any;

  storeId: number;
  containerId: number;
  equipmentTypeCode: string;
  formValid: boolean = false;
  formValue: any;
  busy: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<PosTfgAccountPayWithMoneyEquipmentComponent>,
    private baseService: BaseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private notificationService: NotificationService,
  ) {
    this.tfgAccountDetails = data;
  }

  ngOnInit() {

  }

  paymentChanged(event: {
    storeId: number;
    containerId: number;
    equipmentTypeCode: string;
    formValid: boolean;
    formValue: any;
  }) {
    this.storeId = event.storeId;
    this.containerId = event.containerId;
    this.equipmentTypeCode = event.equipmentTypeCode;
    this.formValid = event.formValid;
    this.formValue = event.formValue;
  }

  save() {
    this.busy = true;
    const payload = {
      validationRequestId: this.tfgAccountDetails.requestId,
      storeId: this.storeId,
      containerId: this.containerId,
      equipmentTypeCode: this.equipmentTypeCode,
      amountPaid: this.formValue.amountTendered,
      paymentData: this.formValue,
      subType: this.tfgAccountDetails.subType,
      salesOrderNumber: this.tfgAccountDetails.salesOrderNumber,
      invoiceNumber: this.tfgAccountDetails.invoiceNumber,
    };

    const dialogData: OiGroupDialogData = {
      title: 'Authorizing TFG Credit Card',
      function: 'portal_oi_group_payment_tfg_account_payment_from_money_equipment',
      postBody: payload
    };


    const ref = this.dialog.open(OiGroupProcessDialogComponent, {
      data: dialogData,
      width: '450px'
    });

    ref.afterClosed().subscribe(oiResult => {
      this.busy = false;
      if (oiResult.responseCode === 0 && oiResult.data && oiResult.data.groupProcessedSuccessfully === true) {
        this.baseService.executeCommand<any>('portal_tfg_vision_request_id_from_outgoing_message_group_id', { outgoingMessageGroupId: oiResult.data.outgoingMessageGroupId })
          .subscribe(response => {
            if (response.responseCode === 0) {
              this.generatePaymentReceipt({ ...this.data, ...oiResult.data, requestId: response.data.requestId });
            } else {
              // this.dialogRef.close(true);
            }
          })
      }
    });
  }

  generatePaymentReceipt(data: any) {
    const ref = this.dialog.open(PrintTriggerDialogComponent, {
      data: {
        title: 'Generating TFG Payment Receipt',
        function: 'portal_tfg_account_create_print_trigger',
        postBody: Object.assign(data, { documentType: 'TFG-RECEIPT' })
      },
      width: '600px'
    });

    ref.afterClosed().subscribe(
      response => {
        this.baseService.executeCommand<any>('portal_tfg_account_payment_receipt_download_config', { outgoingMessageGroupId: data.outgoingMessageGroupId, printTriggerId: response })
          .subscribe(response => {
            if (response.responseCode === 0) {
              this.notificationService.success('Downloading TFG Payment Receipt');
              this.baseService.downloadResource(response.data.apiResourceKey, response.data.fileName, response.data.mimeType);
              this.dialogRef.close(true);
            } else {
              this.dialogRef.close(true);
            }
          })
      },
      error => {
        this.dialogRef.close(true);
      });
  }


}
